import { Button, Typography, styled, Skeleton } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatCategories } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/PayConstants/components/FreeHypothesis/helpers/dataHelpers';
import Flex from 'ui/Flex/Flex';

interface ConditionalButtonProps {
    isSelected: boolean;
}
const StyButton = styled(Button)<ConditionalButtonProps>(
    ({ theme, isSelected }) => ({
        backgroundColor: isSelected
            ? theme.palette.primary.main
            : theme.palette.common.white,
        color: isSelected
            ? theme.palette.common.white
            : theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white,
        },
    }),
);

const CategorySelect = ({
    category,
    setCategory,
    data,
    allowedCategories,
    isLoading,
}: {
    category: string;
    data: string[];
    setCategory: (value: string) => void;
    allowedCategories: string[];
    isLoading: boolean;
}): React.ReactElement => {
    const { t } = useTranslation();
    return (
        <Flex flexDirection="row" justifyContent="flex-start" paddingY="1rem">
            <Typography
                variant="body1"
                sx={{
                    width: 'fit-content',
                    paddingRight: '10px',
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                {t('humanResources.simulation.freeHypothesis.ifse.category')}
            </Typography>
            <Flex gap={2}>
                {isLoading ? (
                    <Skeleton width={100} height={60} />
                ) : (
                    formatCategories(data).map((item) => (
                        <StyButton
                            key={item}
                            disabled={!allowedCategories?.includes(item)}
                            isSelected={category === item}
                            onClick={() => setCategory(item)}
                        >
                            {item.toUpperCase()}
                        </StyButton>
                    ))
                )}
            </Flex>
        </Flex>
    );
};
export default CategorySelect;
